import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout, updateUser } from '~redux_related/user/actionCreators';
import { Loader } from '~components/loader';
import MobileHeader from '~routes/main/userprofile/mobile-header';
import DesktopHeader from '~routes/main/userprofile/desktop-header';
import Navigation from '~routes/main/userprofile/navigation';
import UserCard from '~routes/main/userprofile/user-card';
import TabSettingsLazy from '~routes/main/userprofile/tab-settings/lazy';
import TabTeamLazy from '~routes/main/userprofile/tab-team/lazy';
import TabEventsLazy from '~routes/main/userprofile/tab-events/lazy';
import TabFeedLazy from '~routes/main/userprofile/tab-feed/TabFeedLazy';
import { checkUserExpirationDateExpired } from '~utils/helpers';
import './style.scss';

function UserProfile({
    isMobile,
    isUserLogouting,
    user,
    logout,
    updateUser,
    isNewsUserLogged,
    isLawsUserLogged,
    isLawsAvailable,
}) {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        window.ym && window.ym(73097359, 'hit', window.location.href);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const availabilityProps = { isNewsUserLogged, isLawsUserLogged, isLawsAvailable, user };
    return (
        <div className="user-profile">
            <div className="main-container">
                {isMobile ? <MobileHeader logout={logout} /> : <DesktopHeader {...availabilityProps} />}
                <div className="user-profile__wrap">
                    {isMobile && (
                        <UserCard user={user} logout={logout} updateUser={updateUser} {...availabilityProps} />
                    )}
                    {isMobile && <Navigation {...availabilityProps} />}
                    <div className="user-profile__tabs-container">
                        <Switch>
                            <Route
                                path="/user/settings"
                                exact
                                render={() => <TabSettingsLazy {...availabilityProps} />}
                            />
                            {isLawsUserLogged && isLawsAvailable && (
                                <Route path="/user/team" exact render={() => <TabTeamLazy user={user} />} />
                            )}
                            {isLawsUserLogged && isLawsAvailable && (
                                <Route path="/user/events" exact render={() => <TabEventsLazy user={user} />} />
                            )}
                            {/* {isLawsUserLogged && isLawsAvailable && (
                                <Route path="/user/feed" exact render={() => <TabFeedLazy user={user} />} />
                            )} */}
                            <Redirect to="/user/settings" />
                        </Switch>
                    </div>
                    {!isMobile && (
                        <UserCard
                            user={user}
                            logout={logout}
                            updateUser={updateUser}
                            isUserLogouting={isUserLogouting}
                            {...availabilityProps}
                        />
                    )}
                </div>
            </div>
            {isUserLogouting && <Loader />}
        </div>
    );
}

UserProfile.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    isUserLogouting: PropTypes.bool.isRequired,
    user: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        photo: PropTypes.string,
        ut: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
    }).isRequired,
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
    logout: PropTypes.func.isRequired,
    updateUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
    isUserLogouting: state.user.isUserFetching,
    user: state.user,
    isNewsUserLogged: !checkUserExpirationDateExpired(state.user.newsUser.token_expires_at),
    isLawsUserLogged: !checkUserExpirationDateExpired(state.user.lawsUser.token_expires_at),
    isNewsAvailable: state.user.feed_settings && state.user.feed_settings.news,
    isLawsAvailable: state.user.feed_settings && state.user.feed_settings.laws,
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(logout()),
    updateUser: (user) => dispatch(updateUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/index.js